import { Card, DesignV2Scope } from "../design-v2";

/* Phase 11A presentation-only compatibility -- see Train.jsx. No Coach feature
 * is implemented here. */
export default function AICoach() {
  return (
    <DesignV2Scope className="py-6 pb-[var(--lz-v2-bottom-nav-reserved-space)] space-y-3">
      <h1 className="font-lz-v2-display text-xl font-bold tracking-tight text-lz-v2-text-strong">
        AI Coach
      </h1>
      <Card>
        <p className="text-sm text-lz-v2-text-muted">
          Check-in, résultats, décisions, timeline du cycle.
        </p>
      </Card>
    </DesignV2Scope>
  );
}
